import { type ReactNode } from "react";

import { cn, customTv } from "#utils";

import type { AlertSeverity } from "./Alert";
import type { VariantProps } from "tailwind-variants";

/** AlertTitleProps interface for the AlertTitle component */
export interface AlertTitleProps extends VariantProps<typeof titleStyles> {
  /** The title content */
  children: ReactNode;
  /** The severity to determine color */
  severity?: AlertSeverity;
  /** Additional CSS classes */
  className?: string;
}

const titleStyles = customTv({
  base: "mb-1 font-semibold",
  variants: {
    severity: {
      success: "text-positive-700",
      info: "text-informative-700",
      warning: "text-warning-700",
      error: "text-negative-700",
      secondary: "text-neutral-700",
    },
  },
  defaultVariants: {
    severity: "success",
  },
});

export function AlertTitle({ children, severity = "success", className }: AlertTitleProps) {
  return <div className={cn(titleStyles({ severity }), className)}>{children}</div>;
}
